























































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic,
  Configuration
} from "@/configuration";
import { EventBus } from "@/main";
import API from "@/api";
import axios from "axios";

@Component({
  metaInfo() {
    return {
      title: "Landing",
      titleTemplate: TitleTemplatePublic,
      htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang
      }
    };
  },
  data() {
    return {
      validtop: true,
      validbottom: false,
      dialog: false,
      canPress: true,
      amounts: {
        financed: 0,
        lastThirtyDays: 0,
        render: {
          financed: 0,
          lastThirtyDays: 0
        }
      },
      name: "",
      email: "",
      phone: "",
      via: this.$route.query.via != null ? this.$route.query.via : "Landing",
      nameRules: [
        (v: any) => !!v || "Ingrese nombre",
        (v: any) =>
          v.length <= 255 || "Nombre no puede exceder los 255 caracteres."
      ],
      emailRules: [
        (v: any) => !!v || "Ingrese correo electrónico",
        (v: any) => /.+@.+/.test(v) || "La dirección debe ser válida"
      ],
      phoneRules: [
        (v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros"
      ]
    };
  },
  async beforeMount() {
    let amounts: any = await API.getAmounts();
    if (amounts.principal != null) {
      this.$store.commit("setAmountFinanced", parseInt(amounts.principal));
      this.$data.amounts.financed = parseInt(amounts.principal);
    } else {
      this.$data.amounts.financed = this.$store.state.amountFinanced;
    }

    this.$data.amounts.lastThirtyDays = parseInt(amounts.secundario);

    let steps = 20;
    let timePerStep = 1;

    for (
      let i = this.$data.amounts.financed / steps;
      i < this.$data.amounts.financed;
      i += this.$data.amounts.financed / steps
    ) {
      await new Promise((res, rej) => {
        setTimeout(() => {
          // @ts-ignore
          this.$data.amounts.render.financed = parseInt(i);
          res();
        }, timePerStep);
      });
    }

    this.$data.amounts.render.financed = this.$data.amounts.financed;
  },
  methods: {
    async validateTop(response) {
      this.$data.canPress = false;
      API.landing
        .landing(
          this.$data.name,
          this.$data.email,
          this.$data.phone,
          this.$data.via
        )
        .then((data: any) => {
          this.$data.dialog = true;
          setTimeout(() => {
            this.$router.push({
              path: "/"
            });
          }, Configuration.Redirection.timeout);
        })
        .catch((error: any) => {
          this.$data.canPress = true;
          this.$data.error = "Error";
          if (error.message.nombre != null) {
            EventBus.$emit("snack-error", error.message.nombre[0]);
          }
          if (error.message.mail != null) {
            EventBus.$emit("snack-error", error.message.mail[0]);
          }
        });
    },
    async validateBottom(response) {
      this.$data.canPress = false;
      API.landing
        .landing(
          this.$data.name,
          this.$data.email,
          this.$data.phone,
          this.$data.via
        )
        .then((data: any) => {
          alert(data);
          this.$data.dialog = true;
          setTimeout(() => {
            this.$router.push({
              path: "/"
            });
          }, Configuration.Redirection.timeout);
        })
        .catch((error: any) => {
          alert(error);
          this.$data.canPress = true;
          this.$data.error = "Error";
          if (error.message.nombre != null) {
            EventBus.$emit("snack-error", error.message.nombre[0]);
          }
          if (error.message.mail != null) {
            EventBus.$emit("snack-error", error.message.mail[0]);
          }
        });
    }
  }
})
export default class Landing extends Vue {}
